import {
  gridPanelOpened,
  gridPanelTabChanged,
  selectGridPanel,
} from 'features/layout/features/content/contentSlice';
import { openLastActiveFileSaga } from 'features/content-library/sagas/openLastActiveFileSaga';
import { openLastActiveWhiteboardSaga } from 'features/content-library/sagas/openLastActiveWhiteboardSaga';
import { openLastActiveScreenshareSaga } from 'features/screenshare/sagas/openLastActiveScreenshareSaga';
import { GridPanelName } from 'features/layout/features/content/types';
import { call, put, select } from 'redux-saga/effects';

export function* onGridPanelTabChangedSaga(action: ReturnType<typeof gridPanelTabChanged>) {
  const currentGridPanel: GridPanelName = yield select(selectGridPanel);

  if (action.payload === 'contentLibrary' && currentGridPanel === 'contentLibrary') {
    yield call(openLastActiveFileSaga);
  }

  if (action.payload === 'whiteboard' && currentGridPanel === 'whiteboard') {
    yield call(openLastActiveWhiteboardSaga);
  }

  if (action.payload === 'screenshare' && currentGridPanel === 'screenshare') {
    yield call(openLastActiveScreenshareSaga);
  }

  if (action.payload === 'external') {
    yield put(gridPanelOpened('external'));
  }
}
